// suit pdp flickity starts
document.addEventListener('DOMContentLoaded', function () {

  var elem = document.querySelector('.main-coord-products-container');

  if (!elem) return;

  new Flickity(elem, {
    cellSelector: '.coord-products-inner-wrapper',
    cellAlign: 'left',
    contain: true,
    wrapAround: false,
    groupCells: false,
    pageDots: false,
    prevNextButtons: false,
    draggable: true,
    freeScroll: false,
    imagesLoaded: true
  });

});
// suit pdp flickity ends

// Start - Lazyload for menubar drawer
var lazyImgMenubar = document.querySelectorAll("img.lazyimg_menubar");  
//console.log('lazyImgMenubar',lazyImgMenubar);
$('.desk-menu-icon,.sticky_nav_menu').click(function(){
  $('body').addClass('open_newmenu');
  lazyImgMenubar.forEach(function(img) {
    img.src = img.dataset.imgsrc;
    img.classList.remove('lazyimg_menubar');            
  });
  if(lenisOBJ != null){
    lenisOBJ.destroy();
  }
})


$('.custom-pro-quickview-btn-wrap button').click(function(){
    lazyImgMenubar.forEach(function(img) {
    img.src = img.dataset.imgsrc;
    img.classList.remove('lazyimg_menubar');            
  });
  if(lenisOBJ != null){
    lenisOBJ.destroy();
  }
})


$('.menu-close , .menu-overlay,.close-product-quickview').click(function(){
  $('body').removeClass('open_newmenu');
  if(lenisOBJ != null){
    lenisOBJ = new Lenis({
      lerp: 0.07,
      smooth: true
    });
  }
})





// END - Lazyload for menubar drawer



$('.new-menu-main .search_block').click(function(){
  $('body').removeClass('open_newmenu');
  $('header.Header').addClass('open_searchbar');
  $('.stDesktopSearchBox-wrapper input').focus();
  $('body').addClass('open_searchbar-overlay');
 
});

$(document).ready(function () {
  $(".new-menu-main .menu-search .search_block,.left_Search").on("click", function () {   
    if ($(window).width() <= 863) {
      $(".st-searchIcon-mobile").trigger("click");
      $('body').addClass('st-mobile-margin');
      $(".st-search-bar").css("display", "block");
      $('.stDesktopSearchBox-wrapper input').focus();
      $('.st-searchmobile-Wrapper input').focus();
      
     
    }
  });
  $('#st-backMobile').click(function(e){
      $('body').removeClass('open_searchbar-overlay');        
      $('header.Header').removeClass('open_searchbar');
    });
  });


if (window.innerWidth < 786) {
} else{
function successCallback(position) {
  // console.log("position",position);
}
}

if($('body').hasClass('template-rtw')){
  // console.log("RTW")
  if(window.location.href.includes("#modal")){
    $('.custom_variant').click(function () {
      // $('[id="addtocart-handle"]').text('Save Changes').append('<div class="add-cart-loader"></div>');
      // console.log("Save Changes")
    })
  }
}
// else{
//   console.log("other product")
// }

// if($(window).width() > 1008){
//   (function() {
//     initSlideshow();
//   })();
//   function initSlideshow() {
//     let maintotal = $('.Product__Gallery').height();
//     let height1 = $('.main_pgp_image.secondlast-item').height();
//     let height2 = $('.main_pgp_image.last-item').height();
//     let finalht = (maintotal - (height1 + height2));
//     $('.Product__InfoWrapper').css("height", (finalht -100) );
//     let divht = $('.template-product .Product__Info').height() / 2;
//     let scht = $(window).height() / 2;
//     let totalll = scht - divht + 15 + "px";
//     $('.template-product .Product__Info').css("top", (totalll));
//     $(document).on( 'scroll', function(){
//       $('.template-product .Product__Info').css("top", (totalll) );
//     });
//   }
// }

function manufacturing() { 

 $(".productmeta-right .washcare_right" ).on( "click", function() {
    $('body').addClass('drawer-open');
    $('.washcare').removeClass('hide');
    $('.size-fit,.alteration-refund,.manufacturing-details,.weave,.mill').addClass('hide');
  });

  $(".productmeta-right .size_fit" ).on( "click", function() {
    $('body').addClass('drawer-open');
    $('.size-fit').removeClass('hide');
    $('.washcare,.alteration-refund,.manufacturing-details,.weave,.mill').addClass('hide');
  });

  $(".productmeta-right .alteration_refund_exchange , .guaranteed_data .guaranteed_link a" ).on( "click", function() {
    $('body').addClass('drawer-open');
    $('.alteration-refund').removeClass('hide');
    $('.washcare,.size-fit,.manufacturing-details,.weave,.mill').addClass('hide');
  });
  
  $(".productmeta-right .manufacturing_details" ).on( "click", function() {
    $('body').addClass('drawer-open');
    $('.manufacturing-details').removeClass('hide');
    $('.washcare,.alteration-refund,.size-fit,.weave,.mill').addClass('hide');
  });

  $(".material_data .weave_data" ).on( "click", function() {
    $('body').addClass('drawer-open');
    $('.weave').removeClass('hide');
    $('.washcare,.alteration-refund,.size-fit,.manufacturing-details,.mill').addClass('hide');
  });
  
  $(".material_data .meta_Mill_Name" ).on( "click", function() {
    $('body').addClass('drawer-open');
    $('.mill').removeClass('hide');
    $('.washcare,.alteration-refund,.size-fit,.manufacturing-details,.weave').addClass('hide');
  });

  // $('.productmeta-right a').click(function(){
  //   $('body').addClass('drawer-open'); weave_data
  // });
  $('.care-drawer-main h3, .care-drawer-overlay').click(function(){
      $('body').removeClass('drawer-open');
  });

}
(function() {
   manufacturing();
})();


$(document).ready(function() {
  $('.collection-fix-bar .categ a, [data-sort-button]').click(function(){
    $('body').removeClass("open-coll-filter");
    $('body').removeClass("open-collection-collection"); 
    $('body').toggleClass("open-collection-category"); 
  });
  
  // $('.collection-fix-bar .coll a').click(function(){
  //   $('body').removeClass("open-collection-category");
  //   $('body').removeClass("open-coll-filter");
  //   $('body').toggleClass("open-collection-collection");
  // });
  
  $('.collection-fix-bar .filter a, [data-filters-button]').click(function(){
    $('body').removeClass("open-collection-category");
    $('body').removeClass("open-collection-collection");
    $('body').toggleClass("open-coll-filter");
  });
  
  // $('.close-coll,.coll-all-overlay').click(function(){
  //   if($("body").hasClass("open-collection-category")){
  //     $('body').removeClass("open-collection-category");
  //   }
  //   if($("body").hasClass("open-coll-filter")){
  //     $('body').removeClass("open-coll-filter");
  //   }
  //   if($("body").hasClass("open-collection-collection")){
  //     $('body').removeClass("open-collection-collection");
  //   }
  // });
  
  $(document).on('click','.sub_coll_menu .single_line li',function(){
    // var subHead = $(this).attr('data-subhead');
    // var coll_val = $(this).attr('coll-val');
    $(this).addClass('active');
    $(this).siblings().removeClass('active');
    // $('.Categories-list-main ul li').removeClass('active');    
    // $('.Categories-list-main ul li[coll-val="'+coll_val+'"]').addClass('active');
    // $('#'+subHead).removeClass('hide');
    // $('#'+subHead).siblings().addClass('hide');
    //  //var dataId = $(this).closest('.single_line').attr('data-single')
    //  if($('.single_line:visible').hasClass('col-collapse-toggle')){
    //   setTimeout(function(){
    //     $('.single_line:visible').find('.coll-toggle-btn').click();
    //   },1000)
    //  }
  
    //  window.scrollTo({ top: 0, behavior: 'smooth' });
  
    //  $('body').addClass('skeletonScroll');
    //  setTimeout(function(){
    //   $('body').removeClass('skeletonScroll');
    //      //$('.collpse_btn_inner[data-toggle="'+dataId+'"]').click()
    //  }, 1000);
  });
  $(document).on('click','.sub_coll_menu li.showAllBanner',function(){
    // console.log('click on sub menu');
    $('.banner_prod').removeClass('hide');
  });

  // collection filter --- apply btn --- JS
  // $(document).on("click","[data-collection-apply-btn]",function(e){
  //   e.preventDefault();
  //   if($("[data-collections-menu] .single_line.active .slider_link_banner.active").length == 0){
  //     document.querySelector("[data-collections-menu] .close-coll").click();
  //     return false;
  //   }
  //   // console.log("clicked");
  //   var subHead = $("[data-collections-menu] .single_line.active .slider_link_banner.active").attr('data-subhead');
  //   var coll_val = $("[data-collections-menu] .single_line.active .slider_link_banner.active").attr('coll-val');
  //   $('.Categories-list-main ul li').removeClass('active');    
  //   $('.Categories-list-main ul li[coll-val="'+coll_val+'"]').addClass('active');
  //   $('#'+subHead).removeClass('hide');
  //   $('#'+subHead).siblings().addClass('hide');
  //   //var dataId = $(this).closest('.single_line').attr('data-single')
  //   if($('.single_line:visible').hasClass('col-collapse-toggle')){
  //     setTimeout(function(){
  //       $('.single_line:visible').find('.coll-toggle-btn').click();
  //     },1000)
  //   }
  //   window.scrollTo({ top: 0, behavior: 'smooth' });
  //   $('body').addClass('skeletonScroll');
  //   setTimeout(function(){
  //   $('body').removeClass('skeletonScroll');
  //      //$('.collpse_btn_inner[data-toggle="'+dataId+'"]').click()
  //   }, 1000);
  //   document.querySelector("[data-collections-menu] .close-coll").click();
    
  // });
    
  $(document).on('click','.log-pp',function(){
    $('body').addClass("open-log-pp");
  });
  $(document).on('click','.log-tc',function(){
    $('body').addClass("open-log-tc");
  });
  $(document).on('click','.log-tc-close,.log-bg',function(){
    $('body').removeClass("open-log-tc");
  });
  $(document).on('click','.log-pp-close,.log-bg',function(){
    $('body').removeClass("open-log-pp");
  });
     
});


// COLLECTION FILTERS WITH APPLY BTN CLICK EVENTS --- start
// ==============================================

// // data-collection-category menu click event --- after apply btn clicked
// let collCategories = document.querySelectorAll("[data-collection-category] .btn-slider a");
// collCategories.forEach(aEle => {
//   aEle.addEventListener("click",function(e){
//     // console.log("clicked");
//     e.preventDefault();
//     if(document.querySelector("[data-collection-category] .btn-slider.active") && document.querySelector("[data-collection-category] .btn-slider.active") != this.closest(".btn-slider")){
//       document.querySelector("[data-collection-category] .btn-slider.active").classList.remove("active");
//     }
//     // this.closest(".btn-slider").classList.toggle("active");
//     if(this.closest(".btn-slider").classList.contains("active")){
//       this.closest(".btn-slider").classList.remove("active");
//     }else{
//       this.closest(".btn-slider").classList.add("active");
//     }
//   });
// });
// let collCategoryApplyBtn = document.querySelector("[data-collection-category] [data-collection-category-apply]") || null;
// if(collCategoryApplyBtn){
//   collCategoryApplyBtn.addEventListener("click",function(e){
//     e.preventDefault();
//     if(document.querySelector("[data-collection-category] .btn-slider.active")){
//       location.href = document.querySelector("[data-collection-category] .btn-slider.active a").href;
//     }else{
//       // location.href = location.href.replace(location.search,"");
//       document.querySelector("[data-collection-category] .close-coll").click();
//     }
//   });
// }

// // data-collection-filters apply btn click event
// let filterApplyBtn = document.querySelector("[data-collection-filters] [data-collection-filters-apply-btn]") || null;
// if(filterApplyBtn){
//   filterApplyBtn.addEventListener("click",function(e){
//     e.preventDefault();
//     document.querySelector("[data-collection-filters] .close-coll").click();
//   });
// }

// // data-collection-filters-clear-btn btn click event
// let filterClearBtn = document.querySelector("[data-collection-filters] [data-collection-filters-clear-btn]") || null;
// if(filterClearBtn){
//   filterClearBtn.addEventListener("click",function(e){
//     e.preventDefault();
//     if(document.querySelector(".boost-pfs-filter-button.boost-pfs-filter-clear-all")) document.querySelector(".boost-pfs-filter-button.boost-pfs-filter-clear-all").click();
//   });
// }

// COLLECTION FILTERS WITH APPLY BTN CLICK EVENTS --- end
// ==============================================


$(document).ready(function(){
  // $(".btn-ripple" ).on( "click", function(e) {
  $(document).on("click",".btn-ripple",function(e) {
    $btn = $(this);
    var $offset = $(this).offset();
    $span = $('<span/>');
    var x = e.pageX - $offset.left
    var y = e.pageY - $offset.top;
    $span.addClass('ripple-span');
    $span.css({
      top: y +'px',
      left: x +'px',
    });
    // console.log("$span",$span)
    $btn.append($span);
    window.setTimeout(function() {
      $span.remove();
    },2200);
  });

});











// document.addEventListener("DOMContentLoaded", function () {

//   var elem = document.querySelector('.pro-recently-slider');

//   if (elem) {

//     // Initialize Flickity
//     var flkty = new Flickity(elem, {
//       cellAlign: 'left',
//       pageDots: false,
//       groupCells: '40%',
//       selectedAttraction: 0.03,
//       friction: 0.15,
//       adaptiveHeight: true
//     });

//     // Ensure correct height after images load
//     imagesLoaded(elem, function () {
//       flkty.resize();
//     });

//     // Resize again after all page content loads
//     window.addEventListener('load', function () {
//       flkty.resize();
//     });

//     // Extra safety resize (Shopify loads dynamic content)
//     setTimeout(function () {
//       flkty.resize();
//     }, 600);
//   }

// });



// var flkty = new Flickity('.ProductList', {
//   prevNextButtons: true,
//   pageDots: false,
//   wrapAround: false,
//   contain: true,
//   cellAlign: 'center',
//   adaptiveHeight: false, // disable default
//   watchCSS: true,
//   dragThreshold: 8,
//   groupCells: true,
//   arrowShape: {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
// });

// // Auto-adjust height
// function updateFlickityHeight() {
//   var maxHeight = 0;

//   flkty.slides[flkty.selectedIndex].cells.forEach(function (cell) {
//     var cellElem = cell.element;
//     var cellHeight = cellElem.offsetHeight;
//     if (cellHeight > maxHeight) maxHeight = cellHeight;
//   });

//   flkty.viewport.style.height = maxHeight + 'px';
// }

// // Update on change + on resize
// flkty.on('select', updateFlickityHeight);
// window.addEventListener('resize', updateFlickityHeight);

// // Initial run
// updateFlickityHeight();

 $(document).on('click', '.CollectionToolbar__LayoutType', function() {

    $('body').removeClass('scroll-down');

    setTimeout(function(){
        $('body').removeClass('scroll-down');
    }, 5);

});



// ------------seiper Initialize common code-----





// common.js - initialize all swiper sliders
document.addEventListener("DOMContentLoaded", function () {
  const swiperElements = document.querySelectorAll("[data-swiper]");

  swiperElements.forEach((el) => {
    if (!el.swiperInstance) { // prevent double init
      let userOptions = {};
      const optionAttr = el.getAttribute("data-options");

      if (optionAttr) {
        try {
          userOptions = JSON.parse(optionAttr);
        } catch (e) {
          console.warn("Invalid Swiper options", e);
        }
      }

      const swiper = new Swiper(el, userOptions);
      el.swiperInstance = swiper; // save instance
    }
  });
});


// product.js - add/override options for specific sliders
// document.addEventListener("DOMContentLoaded", function () {
//   const swiperElems = document.querySelectorAll(".mySwiper");

//   swiperElems.forEach((elem) => {
//     if (elem?.swiperInstance) {
//       // Modify existing Swiper instance
//       const swiper = elem.swiperInstance;

//       swiper.params.loop = true;
//       swiper.params.speed = 400;
//       swiper.params.slidesPerView = 4;
//       swiper.params.spaceBetween = 10;

//       swiper.update(); // apply changes
//     }
//   });
// });









// common js
// document.addEventListener("DOMContentLoaded", function () {

//   const swiperElements = document.querySelectorAll("[data-swiper]");

//   swiperElements.forEach((el) => {
//     const swiper = new Swiper(el, {});
//     el.swiperInstance = swiper;
//   });

// });



// // common.js
// document.addEventListener("DOMContentLoaded", function () {
//   const swiperElems = document.querySelectorAll('.mySwiper');

//   swiperElems.forEach((elem) => {
//     // Store swiper instance on the element itself
//     elem.swiperInstance = new Swiper(elem, {
//       loop: true,
//       speed: 400,
//       slidesPerView: 4,
//       spaceBetween: 10
//     });
//   });
// });
